import styled from 'styled-components/macro'

interface ContentSectionProps {
  verticallyCenter?: boolean
  height?: string
  theme: IThemeProps
}
export const ContentSection = styled.section<ContentSectionProps>`
  box-sizing: border-box;
  background-color: transparent;
  height: ${(props: ContentSectionProps) => (props.height ? props.height : '100%')};
  padding: 27px 16px;
  width: 100%;
  display: ${(props: ContentSectionProps) => (props.verticallyCenter ? 'flex' : 'block')};
  justify-content: ${(props: ContentSectionProps) => (props.verticallyCenter ? 'center' : '')};
  flex-direction: ${(props: ContentSectionProps) => (props.verticallyCenter ? 'column' : '')};
  position: absolute;
  top: 0;
  left: 0;
  font-family: ${(props: ContentSectionProps) => props.theme.fontFamily};

  @media (min-width: ${({ theme }: ContentSectionProps) => theme.breakpoint.m}) {
    left: 50%;
    width: 50%;
    padding: 70px 30px;
  }
  @media (min-width: ${({ theme }: ContentSectionProps) => theme.breakpoint.l}) {
    position: relative;
    left: 0;
    width: 100%;
  }
`

export const InstructionalText = styled.p`
  margin: 0 auto;
  margin-bottom: 27px;
  width: 100%;
  max-width: 630px;
  color: #000000;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
`

export const InstructionalImageContainer = styled.div`
  width: 100%;
  text-align: center;
`
